import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["data-clicked"];
var _hoisted_2 = { class: "code-item__main" };
var _hoisted_3 = ["value"];
import { computed, useTemplateRef } from "vue";
import { onClick } from "./click_to_copy";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Code',
    props: {
        code: { type: [String, Number], required: true },
        modifier: String,
        message: { type: String, default: 'Код скопирован' }
    },
    setup: function (__props) {
        var props = __props;
        var classNames = computed(function () { return props.modifier ? "code-item--".concat(props.modifier) : null; });
        var element = useTemplateRef('element');
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(["code-item copy-click", classNames.value]),
                "data-clicked": __props.message,
                onClick: _cache[0] || (_cache[0] = function ($event) { return (_unref(onClick)(element.value)); }),
                ref_key: "element",
                ref: element
            }, [
                _createElementVNode("span", _hoisted_2, [
                    _createElementVNode("input", {
                        class: "code-item__input",
                        type: "text",
                        readonly: "",
                        value: __props.code
                    }, null, 8 /* PROPS */, _hoisted_3),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
